const INITIAL_STATE = { articleText: '', articleData: [], newArticle: { }, loading: false, counter: 0 };

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'ARTICLE_TEXT_CHANGE':
            return { ...state, articleText: action.payload };
        case 'FETCH_ARTICLE':
            return { ...state };
        case 'FETCH_ARTICLE_SUCCESS':
            return { ...state, articleData: action.payload };
        case 'FETCH_ARTICLE_FAIL':
            return { ...state };
        case 'ADD_ARTICLE':
            return { ...state, loading: true };
        case 'LOADING_CHANGE':
            return { ...state, loading: false };
        case 'ADD_ARTICLE_SUCCESS':
            return { ...state, newArticle: action.payload };
        case 'ADD_ARTICLE_FAIL':
            return { ...state };
        case 'ARTICLE_TEXT_CLEAR':
            return { ...state, articleText: '' };
        case 'ARTICLE_TITLE_CHANGE':
            return { ...state, newArticle: { title: action.payload, url: state.newArticle.url, picture: state.newArticle.picture } };
         case 'ARTICLE_URL_CHANGE':
            return { ...state, newArticle: { title: state.newArticle.title, url: action.payload, picture: state.newArticle.picture } };
         case 'ARTICLE_PICTURE_CHANGE':
            return { ...state, newArticle: { title: state.newArticle.title, url: state.newArticle.url, picture: action.payload } };
        case 'SAVE_ARTICLE':
            return { ...state };
        case 'SAVE_ARTICLE_SUCCESS':
            return { ...state };
        case 'SAVE_ARTICLE_FAIL':
            return { ...state };
        case 'PUSH_ARTICLE':
            return { ...state };
        case 'PUSH_ARTICLE_SUCCESS':
            return { ...state };
        case 'PUSH_ARTICLE_FAIL':
            return { ...state };
        case 'INCREMENT_COUNTER':
            return { ...state, counter: action.payload };
        case 'CLEAR_COUNTER':
            return { ...state, counter: action.payload };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/Articles/ArticleReducer.js